import React from 'react';

type Props = {
  cta: string;
  phrase: string;
};
const HelpText: React.FC<Props> = (props) => {
  const { cta, phrase } = props;
  const ctaArr = cta.split('%s');

  return (
    <div className="help-text">
      {ctaArr[0]}{' '}
      <span translate="no" className="no-translate">
        {phrase}
      </span>{' '}
      {ctaArr[1]}
    </div>
  );
};

export default HelpText;
